import React, { useContext } from 'react'
import UserContext, { Roles } from '../../../../contexts/UserContext'
import TenantTable from '../TenantTable'
import AccessesTable from '../AccessesTable'

const PeopleTableSwitch: React.FC = () => {
  const { user } = useContext(UserContext)
  
  if (user?.role === Roles.globalAdmin) {
    return <TenantTable />
  }
  
  return <AccessesTable />
}

export default PeopleTableSwitch
